<template>
  <footer>
    <div class="footer-top">
      <div class="bow">
        <!--  <img src="@/images/footer-top.svg" /> -->
        <rijnja-regelt-het class="rrr"></rijnja-regelt-het>
      </div>
      <p class="slogan">Rijnja regelt het. Sinds 1892.</p>
    </div>
    <div class="footer-content">
      <div class="footer-content-container">
        <nav class="footer-nav">
          <section class="logo-holder">
            <router-link to="/">
              <img
                src="@/images/rijnja-pvp-wit.svg"
                class="logo"
                alt="Rijnja logo wit"
              />
            </router-link>
            <router-link to="/contact" class="contact-button"
              >neem contact met ons op</router-link
            >
          </section>
          <ul class="col">
            <li>
              <router-link to="/wat-wij-doen">Wat wij doen</router-link>
              <ul class="sub">
                <li>
                  <router-link to="/print-uitbesteden"
                    >Print uitbesteden</router-link
                  >
                </li>
                <li>
                  <router-link to="/print-aanbesteden"
                    >Print aanbesteden</router-link
                  >
                </li>
                <li>
                  <router-link to="/secured-printing"
                    >Secured printing</router-link
                  >
                </li>
              </ul>
            </li>
          </ul>

          <ul class="col sub">
            <li class="empty">&nbsp;</li>
            <li>
              <router-link to="/digitaliseren">Digitaliseren</router-link>
            </li>
            <li>
              <router-link to="/printstore">Signing</router-link>
            </li>
          </ul>

          <ul class="col">
            <li>
              <router-link class="link" to="/hoe-doen-wij-dat"
                >Hoe doen wij dat
              </router-link>
              <ul class="sub">
                <li>
                  <router-link class="link" to="/duurzaam"
                    >Duurzaam
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>

          <ul class="col">
            <li>
              <router-link class="link" to="/home#voor-wie"
                >Voor wie doen wij dat
              </router-link>
            </li>
            <li>
              <router-link class="link" to="/over-rijnja"
                >Over ons
              </router-link>
            </li>
            <!--             <li>
              <router-link class="link" to="/werken-bij-rijnja"
                >Werken bij Rijnja</router-link
              >
            </li> -->
            <li>
              <router-link class="link" to="/privacyverklaring"
                >Privacyverklaring</router-link
              >
            </li>
            <li>
              <router-link class="link" to="/contact">Contact</router-link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </footer>
</template>

<script>
import RijnjaRegeltHet from './RijnjaRegeltHet.vue'
export default {
  components: { RijnjaRegeltHet }
}
</script>

<style lang="scss" scoped>
footer {
  margin-top: 40px;
}
.bow {
  height: 132px;
  background-image: url('@/images/footer-top.svg');
  background-repeat: no-repeat;
  background-position: center bottom;
  text-align: center;
}

.slogan {
  text-align: center;
  color: white;
  font-size: 14px;
  font-style: italic;
  background-color: #012169;
  padding-top: 10px;
}

.footer-content {
  background-color: #012169;
}

.footer-content-container {
  padding-top: 30px;
  color: white;
  display: flex;
  flex-direction: column;
  padding: 30px 20px 60px;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
}

.contact-button {
  background-color: transparent;
  border-radius: 25px;
  border: 2px solid white;
  color: white;
  display: block;
  font-size: 11px;
  padding: 10px 18px;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  text-align: center;
}

.footer-nav {
  text-align: center;
  ul {
    list-style-type: none;
    margin: 0;
    padding-bottom: 0;
    padding-left: 0;
    line-height: 35px;
    font-weight: 500;
  }

  a {
    color: white;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &.router-link-exact-active {
      font-weight: 600;
    }
  }

  .sub {
    font-weight: 300;
  }
}

.empty {
  display: none;
}

.logo-holder {
  //text-align: center;

  a {
    width: 243px;
    margin: 20px auto 28px;
  }
}

.logo {
  max-width: 237px;
  padding-top: 40px;
}

@media only screen and (min-width: 768px) {
  .empty {
    display: inline;
  }
  .bow {
    background-size: 100% 61px;
  }
  .footer-content-container {
    flex-direction: row-reverse;
    padding-top: 65px;
  }

  .logo-holder {
    //flex-grow: 1;
    //max-width: 33%;
    //border-right: 1px solid white;

    a {
      width: 200px;
      margin: 20px 0 28px;
    }
  }

  .logo {
    padding-top: 0;
    width: 100%;
    // max-width: 300px;
  }

  .footer-nav {
    flex-grow: 1;
    display: flex;
    justify-content: space-evenly;

    ul {
      text-align: left;
      line-height: 30px;
    }

    li {
      // padding-bottom: 15px;
    }
  }
}
</style>
